(()=>{
  const install=()=>{
    const F=customElements.get('facet-filters-form');
    if(!F||F.__facetStabilityInstalled)return;
    F.__facetStabilityInstalled=true;
    F.__facetRequestId=0;
    F.__facetController=null;

    const parse=(html)=>new DOMParser().parseFromString(html,'text/html');
    const setLoading=(on)=>{
      document.getElementById('ProductGridContainer')?.querySelector('.collection')?.classList.toggle('loading',on);
      ['ProductCount','ProductCountMobile','ProductCountDesktop'].forEach(id=>document.getElementById(id)?.classList.toggle('loading',on));
      document.getElementById('FacetDrawer')?.classList.toggle('loading',on);
    };

    F.renderProductGridContainer=(html)=>{
      const source=parse(html).getElementById('ProductGridContainer');
      const target=document.getElementById('ProductGridContainer');
      if(!source||!target)return;
      target.innerHTML=source.innerHTML;
      const layoutSwitcher=document.querySelector('#FacetFiltersForm layout-switcher');
      const active=layoutSwitcher?.querySelector('.list-view__item--active');
      if(layoutSwitcher&&active&&typeof layoutSwitcher.onButtonClick==='function')layoutSwitcher.onButtonClick(active);
    };

    F.renderProductCount=(html)=>{
      const source=parse(html).getElementById('ProductCount');
      if(!source)return;
      ['ProductCount','ProductCountMobile','ProductCountDesktop'].forEach(id=>{
        const target=document.getElementById(id);
        if(!target)return;
        target.innerHTML=source.innerHTML;
        target.classList.remove('loading');
      });
    };

    F.renderActiveFacets=(doc)=>{
      ['.active-facets-mobile','.active-facets-desktop'].forEach(selector=>{
        const source=doc.querySelector(selector);
        const target=document.querySelector(selector);
        if(source&&target)target.innerHTML=source.innerHTML;
      });
    };

    F.renderAdditionalElements=(doc)=>{
      ['.mobile-facets__open','.facets__open','.sorting'].forEach(selector=>{
        const source=doc.querySelector(selector);
        const target=document.querySelector(selector);
        if(source&&target)target.innerHTML=source.innerHTML;
      });
      const drawer=document.getElementById('FacetFiltersFormMobile')?.closest('facet-drawer');
      if(drawer&&typeof drawer.bindEvents==='function')drawer.bindEvents();
    };

    F.renderFilters=(html,event)=>{
      const doc=parse(html);
      const activeIndex=event?.target?.closest?.('.js-filter')?.dataset?.index;
      const sourceFilters=[...doc.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter')];
      sourceFilters.forEach(source=>{
        if(activeIndex&&source.dataset.index===activeIndex)return;
        const selector=`.js-filter[data-index="${CSS.escape(source.dataset.index||'')}"]`;
        const target=document.querySelector(selector);
        if(target)target.innerHTML=source.innerHTML;
      });
      F.renderActiveFacets(doc);
      F.renderAdditionalElements(doc);
      if(activeIndex){
        const source=sourceFilters.find(x=>x.dataset.index===activeIndex);
        const target=document.querySelector(`.js-filter[data-index="${CSS.escape(activeIndex)}"]`);
        const s=source?.querySelector('.facets__selected');
        const t=target?.querySelector('.facets__selected');
        if(s&&t)t.outerHTML=s.outerHTML;
      }
      document.getElementById('FacetDrawer')?.classList.remove('loading');
    };

    F.renderPage=(searchParams,event,updateURLHash=true)=>{
      F.searchParamsPrev=searchParams;
      const requestId=++F.__facetRequestId;
      if(F.__facetController)F.__facetController.abort();
      const controller=new AbortController();
      F.__facetController=controller;
      setLoading(true);

      const jobs=F.getSections().map(section=>{
        const url=`${window.location.pathname}?section_id=${section.section}&${searchParams}`;
        const cached=F.filterData.find(x=>x.url===url);
        if(cached)return Promise.resolve({html:cached.html,url});
        return fetch(url,{signal:controller.signal,credentials:'same-origin'})
          .then(r=>{if(!r.ok)throw new Error(`Facet request failed: ${r.status}`);return r.text();})
          .then(html=>{
            if(!F.filterData.some(x=>x.url===url))F.filterData=[...F.filterData,{html,url}].slice(-30);
            return {html,url};
          });
      });

      Promise.all(jobs).then(results=>{
        if(requestId!==F.__facetRequestId||controller.signal.aborted)return;
        results.forEach(({html})=>{
          F.renderFilters(html,event);
          F.renderProductGridContainer(html);
          F.renderProductCount(html);
        });
        if(updateURLHash)F.updateURLHash(searchParams);
        setLoading(false);
        document.dispatchEvent(new CustomEvent('collection:reloaded',{detail:{searchParams}}));
      }).catch(err=>{
        if(err?.name==='AbortError')return;
        if(requestId===F.__facetRequestId)setLoading(false);
        console.error('[facet-stability]',err);
      });
    };
  };

  if(customElements.get('facet-filters-form'))install();
  else customElements.whenDefined('facet-filters-form').then(install);
})();